import { HStack } from '@genial/components';
import React from 'react';
import { RecoilState } from 'recoil';

import { IInvestedAssetsNormalized } from '../../../../store/customerDetail/types';
import { ClubesTable } from '../AssetTable/clubes';
import { CoeTable } from '../AssetTable/coe';
import { CryptoTable } from '../AssetTable/crypto';
import { DirectTreasuryTable } from '../AssetTable/direct-treasury';
import { EquityTable } from '../AssetTable/equity';
import { FixedIncomeTable } from '../AssetTable/fixed-income';
import { FundsTable } from '../AssetTable/funds';
import { LiquiditiesTable } from '../AssetTable/liquidities';
import { isAssetLiquidity } from '../AssetTable/liquidities/utils';
import { PrivatePensionTable } from '../AssetTable/private-pension';
import { StrategiesTable } from '../AssetTable/strategies';
import { isAssetStrategy } from '../AssetTable/strategies/utils';

export interface DynamicAssetTableProps {
  product: IInvestedAssetsNormalized;
  productAtom: RecoilState<{ [key: string]: IInvestedAssetsNormalized | undefined }>;
  onData?: (data: any[]) => void;
}

export const DynamicAssetTable: React.FC<DynamicAssetTableProps> = (props) => {
  const renderTableByProductType = () => {
    if (isAssetStrategy(props.product.marketTypeNormalized)) {
      return <StrategiesTable {...props} />;
    }

    if (isAssetLiquidity(props.product.marketTypeNormalized)) {
      return <LiquiditiesTable {...props} />;
    }

    switch (props.product.marketTypeNormalized) {
      case '1':
        return <FundsTable {...props} />;

      case '2':
        return <ClubesTable {...props} />;

      case '3':
        return <FixedIncomeTable {...props} />;

      case '4':
        return <EquityTable {...props} />;

      case '5':
        return <PrivatePensionTable {...props} />;

      case '6':
        return <DirectTreasuryTable {...props} />;

      case '7':
        return <CoeTable {...props} />;

      case '8':
        return <CryptoTable {...props} />;

      default:
        return <HStack />;
    }
  };

  return renderTableByProductType();
};
